import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { addUserToAccount } from './AccountService';
import { getAllUsers } from '../Users/UserService';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import listGroupUsers from './GroupUserList';

const AttachUser = ({ listAccountUsers }) => {
  const [open, setOpen] = useState(false);
  // const [users, setUsers] = useState<any[]>([])
  const [users, setUsers] = useState<any[]>([]);
  // const navigate = useNavigate();

  // const [firstName, setFirstName] = useState('');
  // const [status, setStatus] = useState('');
  // const [startDate, setStartDate] = useState('')
  // const [endDate, setEndDate] = useState('')

  const [selectedUserId, setSelectedUserId] = useState(null); // State to hold the selected user ID

  const { accountid } = useParams();
  // const { userid } = useParams()
  //const { groupid } = useParams();
  // const handleChange = (event) => {
  //     //setName(Number(event.target.value) || '');
  // };

  const handleChange = (userid) => {
    setSelectedUserId(userid); // Update the selected user ID when the user is changed
  };

  const handleClickOpen = () => {
    listUsers();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    listUsers();
  }, []);

  function listUsers() {
    getAllUsers()
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function attachSelectedUser(accountid, userid) {
    addUserToAccount(accountid, userid)
      .then(() => {
        // appProgrammeList();
        listAccountUsers();
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Select User</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedUserId || ''} // Use selectedAppId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput label="Select User" id="demo-dialog-native" />
                }
              >
                {/* Ensure "Select Item" option is selected by default */}
                <option value={''} disabled>
                  Select User
                </option>
                {/* Map over items to generate options */}
                {users.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.firstName} {item.lastName}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={addProgrammeAssignment(progid, selectedProgrammeId)}>Add</Button> */}
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button onClick={() => attachSelectedUser(accountid, selectedUserId)}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachUser;
